module.exports = __webpack_public_path__ + "img/gh.be5967a1.svg";